import script from "./a-employee-timeblock-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./a-employee-timeblock-header.vue?vue&type=script&setup=true&lang=ts"

import "./a-employee-timeblock-header.vue?vue&type=style&index=0&id=4c39876b&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c39876b"]])

export default __exports__